export const BEAUTY_TOPICS: Record<string, string[]> = {
  fragrance: [
    "How would you describe the scent?",
    "What was your first impression?",
    "What was the strength of the scent?",
    "How long did the scent last?",
  ],
  skincare: [
    "How easy was it to apply?",
    "How did your skin feel after using it?",
    "What changes did you notice?",
  ],
  makeup: [
    "What level of coverage did it give?",
    "How did it look throughout the day?",
    "What was it like to apply?",
    "How long did it last?",
  ],
  bodycare: [
    "How would you describe the scent?",
    "How did your skin feel after using it?",
    "What changes did you notice?",
  ],
  haircare: [
    "How did your hair feel after using it?",
    "How would you describe the scent?",
    "What changes did you notice?",
  ],
};

// Uses the last but one hex digit of the ID to determine whether to hide or show topics,
// with values 0-7 showing topics and 8-f hiding topics
export function hideForABTest(orderId?: string | null): boolean {
  if (!orderId) return false;
  const lastChar = orderId.replace(/-/g, "").slice(-2, -1).toLowerCase();
  return parseInt(lastChar, 16) >= 8;
}

export type SmartPromptsOverride = "on" | "off" | undefined;

export function getReviewTopicsForCampaign(
  showSmartPrompts: boolean,
  category: string,
  subcategory: string,
  orderId?: string,
  override?: SmartPromptsOverride,
): string[] {
  if (override === "off") return [];
  if (!showSmartPrompts) return [];
  if (category.toLowerCase() !== "beauty") return [];
  if (override !== "on" && hideForABTest(orderId)) return [];
  return BEAUTY_TOPICS[subcategory.toLowerCase()] ?? [];
}

export type SmartPromptsTrackingPayload =
  | {
      metadata: {
        tests: [
          {
            id: 3;
            name: "smart_prompts_ab_test_static";
            variation: { id: "A"; name: "smart_prompts_static_shown" };
          },
        ];
        smart_prompts: {
          prompts: string[];
          shown_count: number;
          category: string;
          subcategory: string;
        };
      };
    }
  | {
      metadata: {
        tests: [
          {
            id: 3;
            name: "smart_prompts_ab_test_static";
            variation: { id: "B"; name: "smart_prompts_static_control" };
          },
        ];
      };
    };

export function buildSmartPromptsPayload(
  category: string,
  subcategory: string,
  orderId?: string | null,
  override?: SmartPromptsOverride,
): SmartPromptsTrackingPayload | null {
  if (category.toLowerCase() !== "beauty") return null;
  if (subcategory.toLowerCase() === "other") return null;

  const topics = getReviewTopicsForCampaign(
    true, // not in preview mode when we are building the payload
    category,
    subcategory,
    orderId ?? undefined,
    override,
  );
  const shown = topics.length > 0;

  if (shown) {
    return {
      metadata: {
        tests: [
          {
            id: 3,
            name: "smart_prompts_ab_test_static",
            variation: { id: "A", name: "smart_prompts_static_shown" },
          },
        ],
        smart_prompts: {
          prompts: topics,
          shown_count: topics.length,
          category,
          subcategory,
        },
      },
    };
  }

  return {
    metadata: {
      tests: [
        {
          id: 3,
          name: "smart_prompts_ab_test_static",
          variation: { id: "B", name: "smart_prompts_static_control" },
        },
      ],
    },
  };
}
